import { render, staticRenderFns } from "./AddUpdateBeneficiary.vue?vue&type=template&id=01bbc28e"
import script from "./AddUpdateBeneficiary.vue?vue&type=script&lang=js"
export * from "./AddUpdateBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports